import * as React from 'react'
import { SVGProps } from 'react'
const ChatIcon = ({ fill = '#2B4D5F', ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={26}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={fill}
        d="M12.5 25.5C19.404 25.5 25 19.904 25 13S19.404.5 12.5.5 0 6.096 0 13s5.596 12.5 12.5 12.5Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12.719 18.723a8.99 8.99 0 0 0 1.628-.266c.658.2 1.354.246 2.033.133a.788.788 0 0 1 .08-.006c.243 0 .561.14 1.024.437v-.488a.476.476 0 0 1 .243-.415c.202-.115.39-.245.56-.39.675-.572 1.057-1.334 1.057-2.142a2.564 2.564 0 0 0-.125-.786 6.22 6.22 0 0 0 .49-1.195c.392.587.601 1.276.604 1.98 0 1.099-.511 2.122-1.395 2.87-.148.125-.303.24-.465.346v1.141a.485.485 0 0 1-.773.385 11.753 11.753 0 0 0-.937-.633 2.366 2.366 0 0 0-.287-.146c-.267.04-.537.06-.812.06-1.103 0-2.123-.33-2.925-.885ZM6.886 16.44c-1.394-1.182-2.199-2.792-2.199-4.518 0-3.526 3.327-6.344 7.389-6.344 4.061 0 7.389 2.818 7.389 6.344 0 3.526-3.328 6.344-7.39 6.344-.457 0-.906-.035-1.35-.105-.19.045-.955.5-2.058 1.305-.399.292-.965.01-.965-.482v-1.947a7.026 7.026 0 0 1-.816-.597Zm3.866.52c.034 0 .068.003.102.008.398.067.808.102 1.222.102 3.431 0 6.177-2.327 6.177-5.148 0-2.82-2.746-5.147-6.177-5.147-3.43 0-6.178 2.327-6.178 5.147 0 1.364.642 2.648 1.776 3.61.287.24.598.458.935.65a.597.597 0 0 1 .304.518v1.123c.872-.585 1.446-.863 1.84-.863Zm-1.825-3.84a.964.964 0 0 1-.97-.958c0-.53.434-.958.97-.958.535 0 .968.429.968.958a.963.963 0 0 1-.968.957Zm3.149 0a.964.964 0 0 1-.969-.958c0-.53.434-.958.969-.958.535 0 .968.429.968.958a.963.963 0 0 1-.968.957Zm3.149 0a.964.964 0 0 1-.969-.958c0-.53.434-.958.969-.958.535 0 .969.429.969.958a.963.963 0 0 1-.969.957Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .5h25v25H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ChatIcon
